///////////////////
// Auto-generated
// Do not edit!!!
///////////////////
import { Component, ViewChild } from '@angular/core';
import { KbNumericInputBaseComponent } from './../numeric-input.base.component';
import { NumericTextBoxComponent } from '@progress/kendo-angular-inputs';

@Component({
    selector: 'kb-percent-text-box',
    templateUrl: './percent-text-box.component.html',
})
export class KbPercentTextBoxComponent extends KbNumericInputBaseComponent {
    @ViewChild('percentInput')
    public percentInput: NumericTextBoxComponent;
}



// WEBPACK FOOTER //
// C:/Users/vjug.INFODESIGN/OtvoreniGrad2/app/src/app/shared/components/percent-text-box/percent-text-box.component.ts